// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2Cs6B","title":"Info_title__1Bawx","selects":"Info_selects__2NEA_","requiredAsterisk":"Info_requiredAsterisk__18dO7"};